import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AdminStore {
  activeTenantId: string | null;
  activeTenantName: string | null;
  verifiedRole: string | null;
  setActiveTenant: (id: string, name: string) => void;
  clearActiveTenant: () => void;
  setVerifiedRole: (role: string | null) => void;
}

export const useAdminStore = create<AdminStore>()(
  persist(
    (set) => ({
      activeTenantId: null,
      activeTenantName: null,
      verifiedRole: null,
      setActiveTenant: (id, name) => set({ activeTenantId: id, activeTenantName: name }),
      clearActiveTenant: () => set({ activeTenantId: null, activeTenantName: null }),
      setVerifiedRole: (role) => set({ verifiedRole: role }),
    }),
    {
      name: 'buildc-admin',
      partialize: (state) => ({
        activeTenantId: state.activeTenantId,
        activeTenantName: state.activeTenantName,
      }),
    }
  )
);
